import { gql } from '@apollo/client';

// Authed — the caller's linked kids, trimmed to just what the invite
// checklist needs (id, name, thumbnail). The fuller variant with liveness
// fields lives in graphql_profiles.ts; this lean copy avoids over-fetching.
export const GET_MY_YOUTUBE_PROFILES = gql`
  query GuardianGroupsMyProfiles {
    getMyYouTubeProfiles {
      id
      name
      thumbnails {
        url
      }
    }
  }
`;

// Authed — the caller's guardian groups (co-parenting circles). Each group
// bundles the guardians who share a set of kids' profiles.
export const MY_GUARDIAN_GROUPS = gql`
  query MyGuardianGroups {
    myGuardianGroups {
      id
      name
      nameIsCustom
      createdAt
      members {
        uid
        displayName
        phoneNumber
        isSelf
      }
      profiles {
        id
        name
        thumbnails {
          url
        }
      }
    }
  }
`;

// Authed — rename a guardian group. Returns the updated group.
export const RENAME_GUARDIAN_GROUP = gql`
  mutation RenameGuardianGroup($groupId: ID!, $name: String!) {
    renameGuardianGroup(groupId: $groupId, name: $name) {
      id
      name
      nameIsCustom
      createdAt
      members {
        uid
        displayName
        phoneNumber
        isSelf
      }
      profiles {
        id
        name
        thumbnails {
          url
        }
      }
    }
  }
`;

// Authed — create (or reuse) a guardian group for the given kids and mint a
// shareable co-parent invite link. Passing `profileIds` binds those kids;
// `phoneNumber` optionally SMSes the link; `groupName` names the group.
export const CREATE_COPARENT_INVITE = gql`
  mutation CreateCoparentInvite(
    $profileIds: [String!]
    $phoneNumber: String
    $groupName: String
  ) {
    createCoparentInvite(
      profileIds: $profileIds
      phoneNumber: $phoneNumber
      groupName: $groupName
    ) {
      success
      link
      token
      smsSent
      message
    }
  }
`;
